module.exports = __webpack_public_path__ + "static/media/essay.321e47f9.png";